export const parseTripJson = (jsonString: string) => {
    try {
      return JSON.parse(jsonString);
    } catch (error) {
      console.error('Error parsing BMS Trip JSON:', error);
      return null;
    }
  };